import { CMM_FILE_EXTENSIONS } from '../../services/cmm-import/importCmmFiles.ts';
import { Protocol } from '../../types/sharedTypeImpl.ts';
import { CmmFilesDialog } from '../cmm-import/cmmFilesDialog.tsx';
import { FileInputButton } from '../fileInputButton.tsx';
import { TestImportDialog } from './importTestDialog.tsx';
import { useTestCmmImport } from './useCmmImportTest.ts';


interface Props {
    protocol: Protocol;
    style?: React.CSSProperties;
}

export function TestCmmImportBar({
    protocol,
    style,
}: Props) {

    const {
        isManualImportDisabled,
        filesDialogState,
        positionsDialogState,
        handleManualImportClick,
        handleFilesDialogSubmit,
        handleLocalFilesSelected,
        handleFilesDialogCancel,
        handlePositionsDialogClose,
    } = useTestCmmImport({ protocol });

    return (
        <>
            <div className='button-bar' style={style}>
                <button
                    onClick={handleManualImportClick}
                    disabled={isManualImportDisabled}
                    children='Test manual import'
                />
                <FileInputButton
                    allowedExtensions={CMM_FILE_EXTENSIONS}
                    onFilesSelected={handleLocalFilesSelected}
                    multiple
                    content='Test local import'
                />
            </div>

            {filesDialogState &&
                <CmmFilesDialog
                    isOpen={true}
                    cmmReports={filesDialogState.cmmReports}
                    initialFilter={filesDialogState.initialFilter}
                    onCancel={handleFilesDialogCancel}
                    onSubmit={handleFilesDialogSubmit}
                />
            }
            {positionsDialogState &&
                <TestImportDialog
                    importResult={positionsDialogState}
                    onClose={handlePositionsDialogClose}
                />
            }
        </>
    );
}